import { render, staticRenderFns } from "./FeaturedPropertiesSection.vue?vue&type=template&id=02be04bd&scoped=true&"
import script from "./FeaturedPropertiesSection.vue?vue&type=script&lang=js&"
export * from "./FeaturedPropertiesSection.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedPropertiesSection.vue?vue&type=style&index=0&id=02be04bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02be04bd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
